import { createContext } from 'react';
import type {
  SegmentSchemaCatalog,
  SchemaSummaryWithFields,
} from '@reach/shared-types/segment-schema-graph';
import type { SegmentFieldValueLoader } from '../SegmentFieldValues/types';

export interface SegmentSchemaCatalogContextValue {
  schemaCatalog: SegmentSchemaCatalog | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  retry: () => void;
  getSchemaById: (schemaId: string) => SchemaSummaryWithFields | undefined;
  getFieldValues?: SegmentFieldValueLoader;
}

export const SegmentSchemaCatalogContext = createContext<SegmentSchemaCatalogContextValue | null>(null);
